/* eslint-disable react-hooks/exhaustive-deps */

import { TaskActionList } from "pages/Task/types"
import { useEffect, useState } from "react"
import { SuccessFetch } from "types"
import { useApi } from "utils"
import { mapAsetPath } from "../functions"

type UseHistoryTaskActionList = {
  task_action_id: string
  enabled?: boolean
}

type Response = {
  payload: TaskActionList[]
}

export function useHistoryTaskActionList({
  task_action_id,
  enabled = true
}: UseHistoryTaskActionList) {
  const api = useApi()
  const [data, setData] = useState<TaskActionList[]>([])
  const [isLoading, setLoading] = useState(false)

  const fetchData = () => {
    setLoading(true)

    const params = {
      task_action_id: task_action_id
    }

    api
      .get("/task_action_history/", { params })
      .then((res: SuccessFetch<Response>) => {
        const data = res.data.payload ?? []
        setData(
          data?.map((item) => ({
            ...item,
            task_action_files: mapAsetPath(item.task_action_files ?? [])
          }))
        )
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false))
  }

  const refetch = () => fetchData()

  useEffect(() => {
    if (task_action_id && enabled) {
      fetchData()
    }

    return () => {
      setData([])
      setLoading(false)
    }
  }, [task_action_id, enabled])

  return {
    data,
    isLoading,
    refetch
  }
}
